// extracted by mini-css-extract-plugin
export var bg = "Spaces-module--bg--b9aea";
export var core = "Spaces-module--core--33e69";